;(function () {
	const initAnnouncementBars = () => {
		const bars = document.querySelectorAll(
			'.section-announcement .announcement-bar__slider:not(.swiper-initialized)'
		)

		bars.forEach((slider) => {
			const section = slider.closest('.section-announcement')
			const nextEl = section?.querySelector('.announcement-bar__nav .swiper-button-next')
			const prevEl = section?.querySelector('.announcement-bar__nav .swiper-button-prev')
			const hasMultipleSlides =
				slider.querySelectorAll('.swiper-wrapper > .swiper-slide').length > 1

			if (!hasMultipleSlides) return

			const autoplay = slider.getAttribute('data-autoplay') === 'true'
			const delay = Number(slider.getAttribute('data-delay')) || 5000
			const loop = slider.getAttribute('data-loop') === 'true'

			new Swiper(slider, {
				slidesPerView: 1,
				speed: 500,
				loop: loop,
				allowTouchMove: true,
				autoplay: autoplay
					? {
							delay: delay,
							disableOnInteraction: false,
					  }
					: false,
				navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
			})
		})
	}

	setTimeout(initAnnouncementBars, 50)
	document.addEventListener('shopify:section:load', initAnnouncementBars)
})()
